import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { catchError, shareReplay } from 'rxjs/operators';
import * as CryptoJS from "crypto-js";

@Injectable({
  providedIn: 'root'
})
export class fciWebsiteService {
  private AllMenuData: any = {
    'total':0,
    'progress':true,
    'data':[],
    'respons':""
  };
  private getZoneRegionNameData:any={
    'total':0,
    'progress':true,
    'data':[],
    'respons':""
  }
  private AllImportantData: any;
  private AllVisitorCounterData: any;
  constructor(private router: Router, private http: HttpClient) { }

  errorMgmt(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Get client-side error\n${error.error.message}`;
    } else {
      errorMessage = `Get server-side error\nError Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }

  getAllMenuList(params: any, serviceName: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/' + serviceName + '/viewall';
    return this.http.post<any>(apiUrl, formParams).pipe(
      shareReplay(1)
      // catchError(this.errorMgmt)
    );
  }

  setImportantLinkData(dataObj: any): any {
    this.AllImportantData = dataObj;
    return true;
  }

  ImportantLinkData(): any {
    return this.AllImportantData;
  }

  setVisitorCounterData(dataObj: any): any {
    this.AllVisitorCounterData = dataObj;
    return true;
  }

  VisitorCounterData(): any {
    return this.AllVisitorCounterData;
  }
 
  setMenuData(dataObj: any): any {
    this.AllMenuData = dataObj;
    window.sessionStorage.removeItem('fcimenudata');
    window.sessionStorage.setItem('fcimenudata',JSON.stringify(this.AllMenuData));
    return true;
  }

  MenuData(): any {
    if(window.sessionStorage.getItem('fcimenudata')){
      let data:any = window.sessionStorage.getItem('fcimenudata');
      this.AllMenuData = JSON.parse(data);
    }
    return this.AllMenuData;
  }


  getFilterMenus(sectionType: any): Array<any> {
    let menus: Array<any> = [];
    let menudata:any;
    if(window.sessionStorage.getItem('fcimenudata')){
      let localmenudata:any = window.sessionStorage.getItem('fcimenudata');
      this.AllMenuData = JSON.parse(localmenudata);
      menudata = this.AllMenuData.data;
    } else {
      menudata = this.AllMenuData.data;
    }
    for (let i = 0; i < menudata.length; i++) {
      if (menudata[i].sectionType == sectionType) {
        menus.push(menudata[i]);
      }
    }
    return menus;
  }


  getService(params: any): Observable<any> {
    // let apiUrl = environment.apiUrl+'api/MenuConfiguration/viewall';
    // return this.http.post(apiUrl,params);
    let apiUrl = environment.apiUrl + 'api/MenuConfiguration/viewall';
    return this.http.post(apiUrl, params, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }



  getPhotoGallery(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/ManageGallery/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }


  countvideophoto(params: any,url:any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + url;
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }


  getGlobal(params: any): Observable<any> {
    let apiUrl = environment.apiUrl + 'api/ManageMenu/viewall';
    let serviceResponse = this.http.post(apiUrl, params);
    return serviceResponse;
  }


  hasPrimaryService(params: any): Observable<any> {
    let apiUrl = environment.apiUrl + 'api/hasprimary';
    return this.http.post(apiUrl, params, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  getPrimarymenu(params: any): Observable<any> {
    let apiUrl = environment.apiUrl + 'api/getprimary-or-division';
    //let apiUrl = environment.apiUrl+'api/MenuConfiguration/viewall';
    return this.http.post(apiUrl, params, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }



  getpageContent(params: any): Observable<any> {
    let apiUrl = environment.apiUrl + 'api/contetdata';
    return this.http.post(apiUrl, params, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }


  getInnerMenuService(params: any): Observable<any> {
    //let apiUrl = environment.apiUrl+'/api/innermenu';
    //let apiUrl = environment.apiUrl+'api/MenuConfiguration/viewall';
    return this.http.post(environment.apiUrl + 'api/innermenu', params, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  getFooterMenu(): Observable<any> {
    //let apiUrl = environment.apiUrl+'api/footermenu';
    //let apiUrl = environment.apiUrl+'api/InnerLeftMenuConfig/viewall';
    return this.http.post(environment.apiUrl + 'api/footermenu', null, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }


  getAllMediaType(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/ManageNewsPage/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  getAwardEvent(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/ManageAwardEvent/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  getAll(parms: any, serviceName: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(parms));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/' + serviceName + '/viewall';
    let serviceResponse = this.http.post(apiUrl, formParams);
    return serviceResponse;

  }
  getAllImpLinks(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/ManageImportantLink/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  getawardlist(params: any): Observable<any> {
    let apiUrl = environment.apiUrl + 'api/ManageNewsPage/viewall';
    return this.http.post(apiUrl, params, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  getDepotList(params: any): Observable<any> {
    let apiUrl = environment.apiUrl + 'api/ManageDepotDetails/viewall';
    return this.http.post(apiUrl, params, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }



  getZoneList() {
    let apiUrl = environment.apiUrl + 'api/get-all-zone';
    return this.http.post(apiUrl, null, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  GetRegionByZoneId(data: any) {
    let apiUrl = environment.apiUrl + 'api/get-region-by-zone-id';
    return this.http.post(apiUrl, data, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  GetDepotByRegionId(data: any) {
    let apiUrl = environment.apiUrl + 'api/get-deopt-by-region-id';
    return this.http.post(apiUrl, data, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  getAllZone() {
    let apiUrl = environment.apiUrl + 'getAllDemoGraphicData';
    let serviceResponse = this.http.get(apiUrl);
    return serviceResponse;
  }
  ///api/get-all-zone
  getAllDepotData(formParams: any) {

    let requestParam = btoa(JSON.stringify(formParams));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'getAllDepotData';
    let serviceResponse = this.http.post(apiUrl, formParams);
    return serviceResponse;
  }

  circularlist(params: any): Observable<any> {
    let apiUrl = environment.apiUrl + 'api/ManageNewsPage/viewall';
    return this.http.post(apiUrl, params, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  getGalleryCat(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/ManageGalleryCategory/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  getDepoData(params: any): Observable<any> {

    let requestParam = btoa(JSON.stringify(params));

    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();

    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };

    // console.log(formParams)

    let apiUrl = environment.apiUrl + 'depoInfo';

    // console.log(apiUrl)

    return this.http.post(apiUrl, formParams, {

      reportProgress: false,

      observe: 'events'

    }).pipe(
      catchError(this.errorMgmt)

    );

  }
  submitVigilanceForm(formParams: any) {
    let requestParam = btoa(JSON.stringify(formParams));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/submitVigilanceForm';
    let Response = this.http.post(apiUrl, formParams);
    return Response;
  }
  getWhatsNew(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/ManagewhatsNew/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  submitContactus(formParams: any) {
    let requestParam = btoa(JSON.stringify(formParams));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/submitContactus';
    return this.http.post(apiUrl, formParams);
  }
  getHospitalData(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/ManageHospitalHQ/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  getCircularDivision(params: any) {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/ManageDivision/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  submitFeedback(formParams: any) {
    let requestParam = btoa(JSON.stringify(formParams));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/submitFeedback';
    let Response = this.http.post(apiUrl, formParams);
    return Response;


  }
  getmsikpiData(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/ManageMISKPI/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  public getCaptcha() {
    let apiUrl = environment.apiUrl + 'getCaptcha';
    let loginResponse = this.http.post(apiUrl, null);
    return loginResponse;
  }
  getimmovableproperty(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/ImmovableProperty/viewall';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  getYear(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/getYear';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  getWhatsNewDetails(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/getWhatsNewDetails';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  getDemographicZone(Params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(Params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/getDemographicZone';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  getAllRegionZonewise(Params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(Params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/getAllRegionZonewise';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  getZoneRegionName(params: any): Observable<any> {// for get all zone and region
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/getZoneRegionName';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  getExploremenu(): Observable<any>{
    let apiUrl = environment.siteURL + 'assets/json-data/explore-menu.json';
    return this.http.get(apiUrl).pipe(
      catchError(this.errorMgmt)
    );
  }

  setZoneRegionNameData(dataObj: any): any {
    this.getZoneRegionNameData = dataObj;
    return true;
  }

  ZoneRegionNameData(): any {
    return this.getZoneRegionNameData;
  }

  getStockData(params:any,fname:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let reqData = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+fname;
    let serviceRes = this.http.post(apiUrl,reqData);
    return serviceRes;
  }
  getWheatProcListing(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/getWheatProcListing';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  getRiceProcListing(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/getRiceProcListing';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  getFarmerProcListing(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/getFarmerProcListing';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  getPaddyProcListing(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/getPaddyProcListing';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  getCoarseProcListing(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/getCoarseProcListing';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  getProcStateUTList(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/getProcStateUTList';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  getFarmerStateUTList(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/getFarmerStateUTList';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  getStockStateUTList(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/getStockStateUTList';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  getStockDateUTList(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/getStockDateUTList';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }

  getMoveStateUTList(params: any): Observable<any> {
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl + 'api/getMoveStateUTList';
    return this.http.post(apiUrl, formParams, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    );
  }
  getqualitycontrolData(params:any,route:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+ 'api/viewMovementData';
    return this.http.post(apiUrl, formParams).pipe(
      catchError(this.errorMgmt)
    );
  }

  getFarmerData(params:any,route:any):Observable<any>{
    let requestParam = btoa(JSON.stringify(params));
    let requestToken = CryptoJS.HmacSHA256(requestParam, environment.apiHashingKey).toString();
    let formParams = { 'REQUEST_DATA': requestParam, 'REQUEST_TOKEN': requestToken };
    let apiUrl = environment.apiUrl+ route;
    return this.http.post(apiUrl, formParams).pipe(
      catchError(this.errorMgmt)
    );
  }


}




